import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { result } from 'lodash';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { EventiService } from './eventi.service';

@Injectable({
  providedIn: 'root'
})
export class EventiDataSource implements DataSource<ModelEventiCalamitosi.EventoDto> {

  private eventoSubject = new BehaviorSubject<ModelEventiCalamitosi.EventoDto[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(null);
  public counter$ = this.countSubject.asObservable();

  constructor(private eventiService: EventiService) {
  }

  loadEventi(ipa: string,
    filter: ModelEventiCalamitosi.EventiSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number) {

    this.loadingSubject.next(true);

    this.eventiService.getList(pageIndex, pageSize, sortDirection, {
      idEvento: filter.idEvento,
      dpgr: filter.dpgr,
      dataEventoDa: filter.dataEventoDa,
      dataEventoA: filter.dataEventoA,
      primaDataChiusuraRaccolta: filter.primaDataChiusuraRaccolta,
      descrizione: filter.descrizione,
      stato: filter.stato,
      ocdpc:filter.ocdpc
    }).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        this.eventoSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  loadDpgrDaAssociare(ipa: string,
    controlList: ModelEventiCalamitosi.EventoDto[],
    aggiungiTutti: string,
    filter: ModelEventiCalamitosi.EventiSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number) {

    this.loadingSubject.next(true);

    this.eventiService.getEventidaAssociare(pageIndex, pageSize, sortDirection, {
      idEvento: filter.idEvento,
      dpgr: filter.dpgr,
      dataEventoDa: filter.dataEventoDa,
      dataEventoA: filter.dataEventoA,
      descrizione: filter.descrizione,
      primaDataChiusuraRaccolta: filter.primaDataChiusuraRaccolta,
      dataEvento:filter.dataEvento,
      stato: filter.stato,
    }).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        let listaDpgrBE: ModelEventiCalamitosi.EventoDto[] = result['content'];
        if (aggiungiTutti === "S") {
          listaDpgrBE.forEach(dpgrBE => {
            dpgrBE.aggiunto = true;
          })
          controlList.forEach(dpgrFE => {
            listaDpgrBE.forEach(dpgrBE => {
              if (dpgrBE.idEvento === dpgrFE.idEvento) {
                if (dpgrFE.aggiunto === true) {
                  dpgrBE.aggiunto = false;
                }
              }
            })
          })
        } else {
          controlList.forEach(dpgrFE => {
            listaDpgrBE.forEach(dpgrBE => {
              if (dpgrBE.idEvento === dpgrFE.idEvento) {
                dpgrBE.aggiunto = true;
              }
            })
          })
        }
        this.eventoSubject.next(listaDpgrBE);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.EventoDto[]> {
    return this.eventoSubject.asObservable();
  }


  loadEventiByRichiesta(ipa: string,
    idRichiesta: number,
    sortDirection: string,
    pageIndex: number,
    pageSize: number) {

    this.loadingSubject.next(true);

    this.eventiService.getEventiListByRichiesta(idRichiesta, pageIndex, pageSize, sortDirection).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        this.eventoSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.eventoSubject.complete();
    this.loadingSubject.complete();
  }

}

